import { observer } from 'mobx-react'
import styles from './PaySuccessModal.module.less'
import { Modal } from 'antd'
import { IconImage } from '../Icon/Icon'
import { WxQr } from '@/helpers/commonConsts'
import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import { uiController } from '@/controllers/uiController'
// import { envHelper } from '@/helpers/envHelper'

export interface PaySuccessModalProps {
  visible: boolean
  title?: string
  materialId?: number
  materialName?: string
  onClose: () => void
}

const PaySuccessModal = observer((props: PaySuccessModalProps) => {
  const download = (id: number, name?: string) => {
    if (uiController.tipWechat()) {
      return
    }
    uiController.modal.confirm({
      title: '提示',
      content: '确定下载该模版吗？',
      okText: '下载',
      cancelText: '取消',
      onOk: () => {
        api.ppt.getPptDownload(id).then((res) => {
          if (res.data?.url) {
            // const url = res.data.url
            // var downloadUrl =
            //   url + (url.indexOf('?') > -1 ? '&' : '?') + 'response-content-disposition=attachment' // 补充强制下载的参数
            // if (name) {
            //   downloadUrl += `;filename=${name}`
            // }
            // commonUtils.downloadFile(downloadUrl)
            // if (commonUtils.isWechat()) {
            //   // commonUtils.downloadFile(
            //   //   envHelper.webHost! +
            //   //     envHelper.apiBasePath! +
            //   //     '/material/download_file?url=' +
            //   //     encodeURIComponent(res.data.url)
            //   // )
            //   commonUtils.downloadFile(commonUtils.replaceDownloadUrl(res.data.url))
            // } else {
            commonUtils.downloadFile(res.data.url)
            // }
          }
        })
      },
    })
  }

  return (
    <Modal
      open={props.visible}
      footer={null}
      closeIcon={false}
      onCancel={props.onClose}
      width={590}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: 18,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        },
      }}
    >
      <div className={styles.paySuccessModal}>
        <div className={styles.modalClose} onClick={props.onClose}>
          <IconImage width={16} className={styles.closeImg} src='IconClose' />
        </div>
        <div className={styles.modalContent}>
          <IconImage src='IconPaySuccess' width={66} />
          <p className={styles.title}>开通成功</p>
          <p className={styles.tips}>
            <IconImage src='IconLihua' width={19} height={23} />
            {props.title}
          </p>
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.qrImg}>
            <img className={styles.img} src={WxQr.CustomerQr} alt='客服二维码' draggable={false} />
          </div>
          <div>
            <p className={styles.footerTitle}>
              <IconImage src='IconPc' style={{ marginBottom: 4 }} width={20} height={24} />
              添加专属客服，有任何问题可联系我们
            </p>
            <p className={styles.footerTips}>(微信扫码即可添加)</p>
            {!!props.materialId && (
              <div
                onClick={() => download(props.materialId!, props.materialName)}
                className={styles.downloadBtn}
              >
                下载模版
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
})

export default PaySuccessModal
